{/* Copyright 2026 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. */}

import {Layout} from '../../../src/Layout';
export default Layout;
import {FunctionAPIGroup} from '../../../src/FunctionAPI';
import {InterfaceType} from '../../../src/types';
import docs from 'docs:@react-aria/color';
import statelyDocs from 'docs:@react-stately/color';
import Anatomy from '/packages/dev/s2-docs/pages/react-aria/ColorAreaAnatomy.svg';

export const section = 'Hooks';
export const description = 'Provides the behavior and accessibility implementation for a color area.';
export const isSubpage = true;

# useColorArea

<PageDescription>{docs.exports.useColorArea.description}</PageDescription>

```tsx render files={["starters/hooks/src/ColorArea.tsx", "starters/hooks/src/ColorArea.css", "starters/hooks/src/ColorThumb.css"]}
"use client";
import {ColorArea} from 'hooks-starter/ColorArea';

<ColorArea defaultValue="hsl(30, 100%, 50%)" xChannel="saturation" yChannel="lightness" />
```

## API

<Anatomy />

```tsx
<ColorArea>
  <ColorThumb />
</ColorArea>
```

<FunctionAPIGroup
  functions={[
    {function: statelyDocs.exports.useColorAreaState, links: statelyDocs.links},
    {function: docs.exports.useColorArea, links: docs.links},
  ]}
/>

### ColorAreaState

<InterfaceType {...statelyDocs.exports.ColorAreaState} links={statelyDocs.links} />

### AriaColorAreaOptions

<InterfaceType {...docs.exports.AriaColorAreaOptions} />

### ColorAreaAria

<InterfaceType {...docs.exports.ColorAreaAria} />
